import { makeStyles } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";

export default makeStyles(theme => ({
    axaLabel:{
        // height: '24px',
        color: '#333333',
        fontFamily: "Source Sans Pro",
        fontSize: '16px',
        fontWeight: '600',
        letterSpacing: '0',
        lineHeight: '14px',
        marginTop:'-5px'
    },

}));

export const getMuiTheme = (selectedTheme) => {
    return createMuiTheme({
        ...selectedTheme,
        overrides: {
            // MuiListItem:{
            //     root:{
            //         paddingTop:0,
            //         paddingBottom:0
            //     }
            // },
                },
    })
}
